
























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import ProvinceLabel from "@/modules/regions/ProvinceLabel/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {ProvinceStore} from "@/modules/regionsv2/province/store";
import {debounce} from "lodash";
import {ProvinceParams} from "@/modules/regionsv2/province/params";
import ProvinceLabelV2 from "@/modules/regionsv2/ProvinceLabelV2/index.vue";

@Component({
    name: "ProvinceSearchSelectorV2",
    components: {ProvinceLabelV2, ProvinceLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: String, default: "Gõ và Lọc theo tỉnh/tp"}) readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';

    @Model("change", {type: Number})
    readonly provinceId!: number;

    @Emit('change')
    handleChange(value?: number) {

        this.$emit("province-name", ProvinceStore.data[value as any]?.name || "");
        return value;
    }

    get provinceIds() {
        return ProvinceStore.ids;
    }

    onSearch(val) {
        const params = {
            ...new ProvinceParams(),
            search: val
        }
        this.handleSearch(params);
    }

    handleSearch = debounce((params: any) => {
        ProvinceStore.paramsChangeProvinceV21(params);
    }, 500)
}
